import { NonActionableWarning } from '@/utils/sentry'
import useClientDomain from '@/composables/client-domain/useClientDomain'

export type TroubleshootingInfo = {
    title: string
    intro: string
    steps: string
}

export class WebSocketConnectionError extends NonActionableWarning {
    code: number
    reason: string
    troubleshooting?: TroubleshootingInfo

    constructor(code: number, reason: string) {
        super('WebSocket connection failed')
        this.code = code
        this.reason = reason

        if (code === 1006 && useClientDomain().embeddedOnWidgetDomain.value) {
            this.troubleshooting = {
                title: 'views.widget.socket_error_1006.troubleshooting_title',
                intro: 'views.widget.socket_error_1006.troubleshooting_intro',
                steps: 'views.widget.socket_error_1006.steps',
            }
        }
    }
}
